import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { AtlasPatologiaPageProvider } from './atlas-patologia.provider';
import { AtlasPatologiaModel, Patologia } from './atlas-patologia.modelview';
import { DetalheAtlasPage } from '../detalhe-atlas/detalhe-atlas';

/**
 * Generated class for the EstudosCientificosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-atlas-patologia',
  templateUrl: 'atlas-patologia.html',
})
export class AtlasPatologiaPage {

  isBrowser: boolean = false;
  model: AtlasPatologiaModel

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public provider: AtlasPatologiaPageProvider,
    public loadingCtrl: LoadingController) {
    this.model = new AtlasPatologiaModel()
    this.isBrowser = this.navParams.get("isBrowser")
  }

  ionViewDidLoad() {
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present().then(() => {
      this.provider.getAtlasPatologia().subscribe(modelProducts => {
        this.model.estudos = modelProducts;
        loading.dismiss()
      }, err => {
        loading.dismiss()
      })
    })
  }

  openAtlas(patologia: Patologia) {
    this.navCtrl.parent.push(DetalheAtlasPage, {
      model: patologia
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/atlas-patologia/atlas-patologia.ts